"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = {
  front: {
    canvas: {
      scale: {
        x: 1000,
        y: 210
      },
      center: {
        x: 450,
        y: 90
      },
      padding: {
        y: 250,
        x: 250
      }
    },
    centerLines: ['edge', 'wall', 'trough', 'console']
  },
  top: {
    canvas: {
      scale: {
        x: 1000,
        y: 500
      },
      center: {
        x: 450,
        y: 340
      },
      padding: {
        y: 250,
        x: 250
      }
    },
    centerLines: ['trough', 'cut-out', 'tap', 'soap-dispenser']
  },
  side: {
    canvas: {
      scale: {
        x: 420,
        y: 196
      },
      center: {
        x: 210,
        y: 70
      },
      padding: {
        y: 28,
        x: 28
      }
    },
    centerLines: ['trough', 'cut-out', 'tap', 'soap-dispenser']
  },
  wall: {
    thickness: 16,
    gutter: 8,
    strokeThickness: 0.6
  },
  text: {
    size: 16,
    space: 20
  },
  lines: {
    space: 15
  },
  shapes: {
    strokeWidth: 1.2,
    strokeColor: 'rgba(0, 0, 0, 1)',
    arrowSize: 12
  },
  explodedTextSpace: 20,
  offsetDistance: 35,
  troughs: {
    round: ['Rio2', 'Baltrum', 'Baltrum_mit_Ueberlauf', 'LANGEOOG_2', 'Langeoog_2_mit_Ueberlauf', 'TOBBY_1', 'TOBBY_mit_Ueberlauf', 'Varius_O', 'Varius_O_mit_Rueckwand', 'Varius_R', 'Varius_R_mit_Rueckwand']
  }
};
exports.state = {
  top: {
    xStep: 0
  }
};